import React from 'react'
import './Components/App.css'
import Router from './core/router'
import Navigation from './Components/Navigation'
import { Routes } from 'react-router'
import { useSelector } from 'react-redux'
import { selectLoadingValue } from './redux/slices/LoadingSlice'
import LoadingComponent from './Components/UI/LoadingComponent'


function App () {
  let isLoading = useSelector(selectLoadingValue)
  return (
    <div className="text-align-center bg-color-black h-auto text-color-white">
      <Navigation />
  
      {isLoading && <LoadingComponent />}
      
      {Router()}
    </div>
  )
}

export default App

